import React from 'react'
import { t } from '../../i18n'

function Cover({ onHome }) {
  return (
    <main className="screen" style={{ background: '#24102a', color: '#fff6e0', alignItems: 'center', justifyContent: 'center', gap: 36, padding: '40px 24px 48px' }}>
      <svg width="180" height="150" viewBox="0 0 180 150" aria-hidden="true">
        <g transform="rotate(-14 62 72)">
          <rect x="20" y="30" width="84" height="84" rx="16" fill="#ee5a4a" stroke="#fff6e0" strokeWidth="3"></rect>
          <circle cx="41" cy="51" r="7" fill="#24102a"></circle>
          <circle cx="62" cy="72" r="7" fill="#24102a"></circle>
          <circle cx="83" cy="93" r="7" fill="#24102a"></circle>
        </g>
        <g transform="rotate(12 131 79)">
          <rect x="96" y="44" width="70" height="70" rx="14" fill="#7fe0b5" stroke="#fff6e0" strokeWidth="3"></rect>
          <circle cx="114" cy="62" r="6" fill="#24102a"></circle>
          <circle cx="148" cy="62" r="6" fill="#24102a"></circle>
          <circle cx="114" cy="96" r="6" fill="#24102a"></circle>
          <circle cx="148" cy="96" r="6" fill="#24102a"></circle>
        </g>
      </svg>

      <div className="slam" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 12, transform: 'rotate(-6deg)' }}>
        <h1 style={{ margin: 0, font: '400 58px/1 var(--display)', color: '#ee5a4a', textAlign: 'center' }}>{t('end.randomWon')}</h1>
        <p style={{ margin: 0, font: '400 40px/1 var(--display)', color: '#7fe0b5', letterSpacing: '.02em' }}>{t('end.fatality')}</p>
      </div>

      <div style={{ flex: '0 0 24px' }}></div>
      <button className="btn btn-primary btn-block" onClick={onHome} style={{ borderColor: '#fff6e0', boxShadow: '0 4px 0 #fff6e0' }}>{t('end.home')}</button>
    </main>
  )
}

export default Cover
